import { render, staticRenderFns } from "./beginSignInDetail.vue?vue&type=template&id=4681e5ad&scoped=true&"
import script from "./beginSignInDetail.vue?vue&type=script&lang=js&"
export * from "./beginSignInDetail.vue?vue&type=script&lang=js&"
import style0 from "./beginSignInDetail.vue?vue&type=style&index=0&id=4681e5ad&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4681e5ad",
  null
  
)

export default component.exports